export default "__VITE_ASSET__3381d95b__"